import { render } from "./AddTeamOwner.vue?vue&type=template&id=1246154d"
import script from "./AddTeamOwner.vue?vue&type=script&lang=js"
export * from "./AddTeamOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__